import { useState } from 'react'
import Input from '../Input/Input'

import style from './form.module.scss'

const Form = ({inputs, button, onSubmit, className}) => {
    const [errors, setErrors] = useState({})
    const [captcha, setCaptcha] = useState(null)

    const validate = () => {
        const newErrors = {}
        let isValid = true

        Object.entries(inputs).forEach(([key, input]) => {
            if (!input.value && input.required) {
                newErrors[key] = 'Это поле обязательно!'
                isValid = false
            } else if (key === 'email' && !/\S+@\S+\.\S+/.test(input.value)) {
                newErrors[key] = 'Некорректный email'
                isValid = false
            } else if (key === 'phone' && !/^[\d\s()+ -]+$/.test(input.value)) {
                newErrors[key] = 'Некорректный телефон'
                isValid = false
            }
        })

        if (captcha) {
            newErrors.captcha = 'Пожалуйста, подтвердите, что вы не робот'
            isValid = false
        }

        setErrors(newErrors)
        return isValid
    }

    const wrapperOnSubmit = (e) => {
        e.preventDefault()
        
        if (validate()) {
            const formData = {}
            Object.entries(inputs).forEach(([key, input]) => {
                formData[key] = input.value
            })
            onSubmit(formData)
        }
    }

    return (
        <form
            className={style.form}
            onSubmit={wrapperOnSubmit}
        >
            {Object.entries(inputs).map(([key, val]) => (
                <Input
                    key={key}
                    type={val.type || 'text'}
                    width={val.width}
                    height={val.height}
                    margin={val.margin}
                    border={val.border}
                    placeholder={val.placeholder}
                    background={val.background}
                    color={val.color}
                    value={val.value}
                    setValue={val.setValue}
                    error={errors[key]}
                    required={val.required}
                    options={val.options}
                />
            ))}

            {errors.captcha && <div style={{ color: 'red' }}>{errors.captcha}</div>}

            {button}
        </form>
    )
}

export default Form